"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientHelper = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const iris_web_core_1 = require("iris-web-core");
const AgoraConsole_1 = require("../util/AgoraConsole");
const AgoraTranslate_1 = require("../util/AgoraTranslate");
class ClientHelper {
    constructor(engine) {
        this._engine = engine;
    }
    leave(client) {
        return __awaiter(this, void 0, void 0, function* () {
            //@ts-ignore isStringUID 是websdk的私有属性
            //如果是string uid 登录
            if (client === null || client === void 0 ? void 0 : client.isStringUID) {
                let userAccount = '';
                userAccount = client.uid;
                const index = this._engine.irisClientManager.userInfoList.findIndex((user) => user.userAccount === userAccount);
                if (index !== -1) {
                    this._engine.irisClientManager.userInfoList.splice(index, 1);
                }
            }
            yield client.leave();
        });
    }
    setClientRole(client_1, role_1) {
        return __awaiter(this, arguments, void 0, function* (client, role, audienceLatencyLevel = NATIVE_RTC
            .AUDIENCE_LATENCY_LEVEL_TYPE.AUDIENCE_LATENCY_LEVEL_ULTRA_LOW_LATENCY) {
            try {
                let webRole = AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_CLIENT_ROLE_TYPE2ClientRole(role);
                //只有观众才能设置 第二个参数。主播不能设置第二个参数
                yield client.setClientRole(webRole, webRole === 'audience'
                    ? AgoraTranslate_1.AgoraTranslate.NATIVE_RTC_AUDIENCE_LATENCY_LEVEL_TYPE2ClientRoleOptions(audienceLatencyLevel)
                    : undefined);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
    sendStreamMessage(client_1, message_1) {
        return __awaiter(this, arguments, void 0, function* (client, message, needRetry = true) {
            try {
                yield client.sendStreamMessage(message);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
    unpublish(client, tracks) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield client.unpublish(tracks);
            }
            catch (e) {
                AgoraConsole_1.AgoraConsole.error(e);
                Promise.resolve(new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED, e));
                throw e;
            }
        });
    }
}
exports.ClientHelper = ClientHelper;
